/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DataModelMassActionValueToChange {
    MIN = 'min',
    MID = 'mid',
    MAX = 'max',
    SPREAD = 'spread',
    MIDPOINT_DIFF = 'midpointDiff',
}
